import React from "react";
import { CloseCircleFilled, PlusOutlined } from "@ant-design/icons";
import { Button, Form, Input, Popconfirm, Select, Space,InputNumber } from "antd";

const RenderedFields = ({ fields, remove, accountData }) => {
  return (
    <>
      {fields.map(({ key, name, ...restField }) => (
        <Space
          key={key}
          style={{
            display: "flex",
            marginBottom: 8,
          }}
          align="baseline"
        >
          <Form.Item {...restField} name={[name, "glAccountId"]}>
            <Select
              style={{ width: "30vh" }}
              showSearch
              options={accountData}
              // defaultValue={accountData}
            />
          </Form.Item>

          <Form.Item {...restField} name={[name, "amount"]}>
            <InputNumber
              style={{ width: "15vh" }}
              formatter={(value) =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
            />
          </Form.Item>

          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => remove(name)}
            okText="OK"
            cancelText="Cancel"
            okButtonProps={{
              style: {
                backgroundColor: "#15CCAE",
                color: "white",
                height: "15%",
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
              },
            }}
            cancelButtonProps={{
              style: {
                height: "15%",
                backgroundColor: "white",
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
              },
            }}
          >
            <CloseCircleFilled
              height={2}
              width={2}
              style={{
                color: "#92428B",
                fontSize: "25px",
                fontWeight: "bolder",
              }}
            />
          </Popconfirm>
        </Space>
      ))}
    </>
  );
};

function AffectedGLEntries(props) {
  const { labelName, accountData, accountName } = props;

  return (
    <>
      <Form.List name={accountName}>
        {(fields, { add, remove }) => (
          <>
            <Button
              onClick={() => add()}
              type="primary"
              icon={<PlusOutlined />}
              style={{
                backgroundColor: "#15CCAE",
                color: "white",
                width: "15vh",
                marginBottom: 20,
              }}
            >
              {labelName}
            </Button>

            <RenderedFields
              fields={fields}
              add={add}
              remove={remove}
              accountData={accountData}
            />
          </>
        )}
      </Form.List>
    </>
  );
}

export default AffectedGLEntries;
